import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  searched, setAuthor, setPageNo
} from "../../features/filter/filterSlice";

export default function Search() {
  const dispatch = useDispatch();
  const { search } = useSelector((state) => state.filter);
  const [input, setInput] = useState(search);

  const match = useMatch("/");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input) {
      return toast.warning("Search value empty",{toastId: 1});
    }

    dispatch(setAuthor(""));
    dispatch(setPageNo(0));
    dispatch(searched(input));
    setInput(search);

    // if user is not in home page, redirect to home page
    if (!match) {
      navigate("/");
    }
  };

  useEffect(() => {
    setInput(search);
  }, [search]);

  return (
    <form onSubmit={handleSubmit}>
      <input
        className="outline-none border-none mr-2"
        type="search"
        name="search"
        placeholder="Search"
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
      />
    </form>
  );
}
